import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { DialPlanActionBranch } from "../_types/dial-plan-action-branch";

@Injectable({
    providedIn: 'root',
})
export class DialPlanActionBranchesService extends Service<DialPlanActionBranch> {
  public override type = 'dialPlanActionBranches';
  public override url = 'Voip/dialPlanActionBranches';
}
